import { isVNode as _isVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
/**
 * @author xiezhixiong
 * @fileoverview 赛事进程 - 淘汰赛
 */
import { defineComponent, reactive, ref, inject } from "vue";
import _ from "lodash";
import {
// raceQuarterOptPC,
// groupTypeOptPC,
// raceTypeOptPC,
raceRoundPC } from "@/config/homePage";
import { homePageContextKey } from "@/context/home-page";
import useHomePageKnockout from "@/hooks/home-page-knockout";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import TeamInfoPopup from "@/components/common/team-info-popup";
import { BattleList, BattleListItem } from "./battle-list";
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
export default defineComponent({
  name: "EliminatedPC",
  setup() {
    const {
      homePageState
    } = inject(homePageContextKey);
    const state = reactive({
      active: 1,
      showPreview: false
    });
    const visible = ref(false);
    const currentTeam = ref({});
    const {
      firstHalf,
      secondHalf,
      isRepechage
    } = useHomePageKnockout(homePageState, state);
    const handleChange = (active, startDate) => {
      // 第一项
      if (!startDate) {
        state.active = active;
        return;
      }
      const openingDate = +new Date(startDate).setHours(23, 59, 59); // 获取开放当天 0 点事件
      const now = +new Date();
      if (now < openingDate) {
        // TODO: 给个提示？
        console.log('当前比赛尚未开始');
        return;
      }
      state.active = active;
    };
    const handleShowPopup = teamInfo => {
      currentTeam.value = teamInfo;
      visible.value = true;
    };
    const handleClosePopup = () => {
      visible.value = false;
    };
    return () => {
      let _slot;
      // const buildList = (
      //   <div class="list-container">
      //     {_.map(state.tableData, (item) => {
      //       return (
      //         <div class="list-item">
      //           <span>
      //             {item.win && (
      //               <img
      //                 class="win-icon"
      //                 src={require("@/assets/img/m/homePage/win-icon.png")}
      //               />
      //             )}
      //             {item.name}
      //           </span>
      //         </div>
      //       );
      //     })}
      //   </div>
      // );
      // 初赛
      const preliminaries = _createVNode("div", {
        "class": "list-box"
      }, [_createVNode("div", {
        "class": "left-list"
      }, [_createVNode("div", {
        "class": "title"
      }, [_createTextVNode("\u3010\u661F\u5149\u8D5B\u533A\u3011\u5BF9\u9635\u961F\u4F0D")]), _createVNode(BattleList, {
        "gameData": firstHalf.value
      }, null)]), _createVNode("div", {
        "class": "right-list"
      }, [_createVNode("div", {
        "class": "title"
      }, [_createTextVNode("\u3010\u706B\u79CD\u8D5B\u533A\u3011\u5BF9\u9635\u961F\u4F0D")]), _createVNode(BattleList, {
        "gameData": secondHalf.value
      }, null)])]);
      // 复活赛
      const Rematch = _createVNode("div", {
        "class": "rematch-box"
      }, [_createVNode("div", {
        "class": "title"
      }, [_createTextVNode("\u3010\u590D\u6D3B\u8D5B\u3011\u5BF9\u9635\u961F\u4F0D ")]), _createVNode("div", {
        "class": "rematch-list  scrollbar-class"
      }, [_createVNode(_resolveComponent("a-row"), {
        "style": "width: 100%"
      }, _isSlot(_slot = secondHalf.value.map(item => _createVNode(_resolveComponent("a-col"), {
        "span": 12
      }, {
        default: () => [_createVNode(BattleListItem, {
          "key": item.id,
          "battleData": item,
          "onSelectTeam": handleShowPopup
        }, null)]
      }))) ? _slot : {
        default: () => [_slot]
      })])]);
      return _createVNode("div", {
        "class": "round-box pc-exclude"
      }, [_createVNode("div", {
        "class": "tab"
      }, [_.map(raceRoundPC[homePageState.raceQuartertype], (item, index) => {
        return _createVNode("div", {
          "onClick": () => {
            var _raceRoundPC$homePage;
            handleChange(item.value, (_raceRoundPC$homePage = raceRoundPC[homePageState.raceQuartertype][index]) === null || _raceRoundPC$homePage === void 0 ? void 0 : _raceRoundPC$homePage.date);
          },
          "class": ["tab-item", state.active === item.value && "active"]
        }, [_createVNode("div", {
          "class": "left"
        }, [_createVNode("span", {
          "class": "label"
        }, [item.label]), _createVNode("span", {
          "class": "date"
        }, [item.dateText])]), item.value !== 4 && _createVNode("img", {
          "class": "divide",
          "src": require("@/assets/img/m/homePage/tt-tab-divide.png")
        }, null)]);
      })]), _createVNode("img", {
        "onClick": () => state.showPreview = true,
        "class": "btn",
        "src": require("@/assets/img/pc/homePage/ttdz-btn.png")
      }, null), !isRepechage(state.active) ? preliminaries : Rematch, _createVNode(PreviewDialog, {
        "visible": state.showPreview,
        "onUpdate:visible": $event => state.showPreview = $event
      }, {
        default: () => [_createVNode("img", {
          "class": "img-against",
          "src": require("@/assets/img/pc/homePage/tt-popup.png")
        }, null)]
      }), _createVNode(TeamInfoPopup, {
        "visible": visible.value,
        "teamInfo": currentTeam.value,
        "onClose": handleClosePopup
      }, null)]);
    };
  }
});